import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color = "#007867" } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 96 96"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M80.4761 16.0003C78.4763 14.0003 31.9319 51.833 28.2075 59.652C28.2075 59.652 28.0521 88.901 33.4177 89.7454C36.3205 89.7454 41.6447 74.3352 42.7663 70.9898C42.9097 70.5622 43.1059 70.1856 43.3793 69.8268C55.0759 54.484 82.4529 17.9773 80.4761 16.0003Z"
        fill={color}
      />
      <path
        d="M11.1672 39.0989C8.65667 40.8149 8.56069 44.0419 10.8482 46.0457C13.9083 48.726 19.2201 53.0631 28.207 59.6654C28.2071 59.6564 28.2071 59.6519 28.2071 59.6519C31.9315 51.8329 78.4759 14.0002 80.4757 16.0002C82.4525 17.9772 55.0755 54.4839 43.3789 69.8267C43.1055 70.1855 42.9093 70.5621 42.7659 70.9897C41.6843 74.2158 36.6946 88.6612 33.7369 89.6877C40.0619 88.4685 46.3589 83.4096 52.1943 76.4228C59.5974 81.3099 64.8374 84.457 68.0228 86.2839C70.2514 87.5621 72.9852 87.0873 74.1568 84.8009C80.9214 71.5993 88.5442 32.4781 89.978 11.9828C90.2092 8.67713 87.531 6.03095 84.2714 6.62737C63.9762 10.3409 25.0572 29.6039 11.1672 39.0989Z"
        fill={color}
      />
      <path
        d="M33.4173 89.7453C33.4172 89.7451 33.4174 89.7455 33.4173 89.7453V89.7453Z"
        fill={color}
      />
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="85.2031"
          id="filter0_i_2450_11994"
          width="82.7866"
          x="7.20508"
          y="4.54297"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            mode="normal"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="-2" dy="-2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
          />
          <feBlend
            in2="shape"
            mode="normal"
            result="effect1_innerShadow_2450_11994"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default SvgComponent;
